import Link from 'next/link';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';

const ReturnTrackingDetails = ({ Texts, returnTrackingDetails }: any) => {
  return (
    <Accordion type="single" collapsible className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg">
      <AccordionItem value="item-1" className="border-none">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">{Texts.returnTracking}</AccordionTrigger>
        <AccordionContent>
          <section className="flex flex-col">
            {returnTrackingDetails?.map((items: any) => {
              const trackingInfo = items?.[0]?.TrackingInfo;
              const trackingLink = trackingInfo?.trackingLink ?? '';
              const externalTrackingLink = trackingInfo?.externalTrackingLink;
              const trackingCode = trackingInfo?.trackingCode ?? '';

              return (
                <div key={trackingCode} className="mb-3">
                  <button
                    className="h-[39px] w-[151px] rounded-md border-[1px] border-foggyGray px-3 py-1.5 text-[15px] font-medium"
                    onClick={() => {
                      const trackingUrl = externalTrackingLink || trackingLink;

                      if (trackingUrl) {
                        window.open(trackingUrl, '_blank', 'noopener,noreferrer');
                      }
                    }}
                  >
                    {Texts?.trackShipmentTitle}
                  </button>
                </div>
              );
            })}
          </section>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default ReturnTrackingDetails;
